module.exports = __webpack_public_path__ + "images/v1001.png?5cbbf216ec8f5bdd36633a4d9720f643";


//////////////////
// WEBPACK FOOTER
// ./static/images/win/v1001.png
// module id = 483
// module chunks = 0